// Create types
export const ORGANIZATION_CREATE_ERROR = 'ORGANIZATION_CREATE_ERROR';
export const ORGANIZATION_CREATE_LOADING = 'ORGANIZATION_CREATE_LOADING';
export const ORGANIZATION_CREATE_SUCCESS = 'ORGANIZATION_CREATE_SUCCESS';
export const ORGANIZATION_CREATE_VIOLATIONS = 'ORGANIZATION_CREATE_VIOLATIONS';
export const ORGANIZATION_CREATE_RESET = 'ORGANIZATION_CREATE_RESET';

// Show types
export const ORGANIZATION_SHOW_ERROR = 'ORGANIZATION_SHOW_ERROR';
export const ORGANIZATION_SHOW_LOADING = 'ORGANIZATION_SHOW_LOADING';
export const ORGANIZATION_SHOW_RETRIEVED_SUCCESS = 'ORGANIZATION_SHOW_RETRIEVED_SUCCESS';
export const ORGANIZATION_SHOW_RESET = 'ORGANIZATION_SHOW_RESET';

// Update types
export const ORGANIZATION_UPDATE_RESET = 'ORGANIZATION_UPDATE_RESET';
export const ORGANIZATION_UPDATE_UPDATE_ERROR = 'ORGANIZATION_UPDATE_UPDATE_ERROR';
export const ORGANIZATION_UPDATE_UPDATE_LOADING = 'ORGANIZATION_UPDATE_UPDATE_LOADING';
export const ORGANIZATION_UPDATE_UPDATE_SUCCESS = 'ORGANIZATION_UPDATE_UPDATE_SUCCESS';
export const ORGANIZATION_UPDATE_RETRIEVE_ERROR = 'ORGANIZATION_UPDATE_RETRIEVE_ERROR';
export const ORGANIZATION_UPDATE_RETRIEVE_LOADING = 'ORGANIZATION_UPDATE_RETRIEVE_LOADING';
export const ORGANIZATION_UPDATE_RETRIEVE_SUCCESS = 'ORGANIZATION_UPDATE_RETRIEVE_SUCCESS';
export const ORGANIZATION_UPDATE_UPDATE_VIOLATIONS = 'ORGANIZATION_UPDATE_UPDATE_VIOLATIONS';

// Delete types
export const ORGANIZATION_DELETE_ERROR = 'ORGANIZATION_DELETE_ERROR';
export const ORGANIZATION_DELETE_LOADING = 'ORGANIZATION_DELETE_LOADING';
export const ORGANIZATION_DELETE_SUCCESS = 'ORGANIZATION_DELETE_SUCCESS';
export const ORGANIZATION_DELETE_RESET = 'ORGANIZATION_DELETE_RESET';

// List types
export const ORGANIZATION_LIST_ERROR = 'ORGANIZATION_LIST_ERROR';
export const ORGANIZATION_LIST_LOADING = 'ORGANIZATION_LIST_LOADING';
export const ORGANIZATION_LIST_RESET = 'ORGANIZATION_LIST_RESET';
export const ORGANIZATION_LIST_VIEW = 'ORGANIZATION_LIST_VIEW';
export const ORGANIZATION_LIST_SUCCESS = 'ORGANIZATION_LIST_SUCCESS';



// WEBPACK FOOTER //
// ./src/store/modules/organization/mutation-types.js